<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const { initClickTracking } = await useTracking();

initClickTracking();

const cspReporter = await useStaticAsset('/global-assets/csp-reporter.js', {
  tag: 'csp-reporter',
});

const scripts = [];

if (cspReporter) {
  scripts.push({
    type: 'text/javascript',
    src: cspReporter.cdnPathname,
    tagPriority: 0,
    id: 'csp-reporter',
  });
}

useHead({
  bodyAttrs: {
    class: 'bg-white',
  },
  noscript: [
    {
      children: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5MMM4LT"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      tagPosition: 'bodyOpen',
    },
  ],
  script: scripts,
});
</script>
